import request from '@/utils/request'
 // 全部订单
export function getAllOrder(data) {
  return request({
    url:'/filmorders/orders/allOrder',
    method:'post',
    data:data
  })
}
// 确定订单--获取数据
export function getConfirmOrder(data) {
  return request({
    url:'/filmorders/orders/getConfirmOrder',
    method:'post',
    data:data
  })
}
// 确定订单--更新手机号
export function updateMobile(data) {
  return request({
    url:'/filmorders/orders/getMobile',
    method:'post',
    data:data
  })
}
// 订单详情及取票码
export function getOrderDetail(data) {
  return request({
    url:'/filmorders/orders/orderView',
    method:'post',
    data:data
  })
}
// 支付成功接口
export function payResult(data) {
  return request({
    url:'/filmorders/orders/qryPayOrderStatus',
    method:'post',
    data:data
  })
}
// 消息列表
export function getNewsList(data) {
  return request({
    url:'/filmaccount/mine/allMessage',
    method:'post',
    data:data
  })
}
// 公告列表
export function getNoticeList(data) {
  return request({
    url:'/filmapi/annment/list',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js